// extracted by mini-css-extract-plugin
module.exports = {"container":"NFT_container__zYBzS","card":"NFT_card__2Zz_G","nftTitle":"NFT_nftTitle__xk9Zi","price":"NFT_price__2YlJR","loaderWrap":"NFT_loaderWrap__2XeDE"};